export const isDedicatedIntegrationCustomer = meStore =>
    !!meStore?.isPoolCustomer &&
    meStore?.pool?.integrationType === "dedicatedIntegration";
